<template>
    <div class="popularity">
        <div class="popularity-pull" :class="popularityHidden ? 'popularityShow' : ''">
            <div class="popularity-pull-top">实时访问热度值</div>
            <div class="popularity-pull-bottom" @click="set_tp_true"></div>
        </div>

        <div class="popularity-push" :class="popularityHidden ? 'popularityHidden': ''">
            <!-- <div class="top-bar">实时访问热度值</div> -->
<!--            <div class="tab-box">-->
<!--                <div class="tab-item" :class="{active: tab == 1}" @click="choseTab(1);qiye=false;zt=false">地方展区</div>-->
<!--                <div class="tab-item" :class="{active: tab == 2 || tab == 3}" @click="qiye=true;selecte_gzw=false;selecte_df=false;zt=false">企业展区-->
<!--                    <div v-if="qiye" class="qiye">-->
<!--                        <div class="gzw1"  @click.stop="choseTab(2);selecte_gzw=true;selecte_df=false;qiye=false">企业展区-国资委推荐企业</div>-->
<!--                        &lt;!&ndash; <div :class="selecte_gzw?'gzw1':'gzw'"  @click.stop="choseTab(2);selecte_gzw=true;selecte_df=false;qiye=false">企业展区-国资委推荐企业</div> &ndash;&gt;-->
<!--                        <div :class="selecte_df?'df1':'df'" @click.stop="choseTab(3);selecte_df=true;selecte_gzw=false;qiye=false">企业展区-地方推荐企业&emsp;</div>-->
<!--                    </div>-->
<!--                </div>    -->
<!--            </div>-->

          <div class="tab-box">
            <div class="tab-item" :class="{active: tab == 1}" @click="choseTab(1)">地方展区</div>
            <div class="tab-item" :class="{active: tab == 2}" @click="choseTab(2)">企业展区</div>

          </div>

            <el-scrollbar class="popularity-chart" v-show="tab == 1">
                <charts ref="charts" :options="chartOptions" />
            </el-scrollbar>
            <el-scrollbar class="popularity-chart"  v-show="tab == 2">
                <!-- <charts ref="yqcharts" :options="secondChartOptions" /> -->
                <charts2 ref="gzwcharts" :options="secondChartOptions" />
            </el-scrollbar>
            <el-scrollbar class="popularity-chart"  v-show="tab == 3">
                <charts3 ref="dfcharts" :options="thirdChartOptions" />
            </el-scrollbar>


            <div class="bottom-bar" @click="set_tp_false"></div>
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import charts from '@/components/charts/index';
import charts2 from '@/components/charts/index2';
import charts3 from '@/components/charts/index3';
import imgBg from '@/assets/img/popularity/popularity-charts-num-icon.png';
import { cityInfo,gzwInfo,dfInfo } from '@/utils/tools.js';

export default {
    name: "ActualTimePopularity",
    components: {
        charts,
        charts2,
        charts3
    },
    data() {
        const img = imgBg;
        // 动态获取图片的URL
        function getImageURL() {
            // 这里可以根据imageName来生成或者获取图片的URL
            return img;
        }
        return {
            qiye:false,
            zt:false,
            selecte_gzw:false,
            selecte_gdf:false,
            selecte_mhzc:false,
            selecte_hzgc:false,
            timer: null,
            // seriesData,
            thumbUps: [],
            secondthumbUps:[],
            thirdthumbUps:[],
            popularityHidden: false,
            chartOptions: {
                grid: {
                    left: 0,
                    right: 10,
                    bottom: 20,
                    top: 20,
                    height: 1600
                },
                legend: {
                    show: false
                },
                xAxis: [
                    {
                        type: "value",
                        axisLabel: {
                            show: false,
                        },
                        interval: 0,
                        min: 0,
                        max: 'dataMax', // 计算最大值
                        splitLine: {
                            show: false,
                        },
                        axisLine: {
                            show: false,
                        },
                        axisTick: {
                            show: false,
                        },
                    }
                ],
                yAxis: [
                    {
                        inverse: true,
                        type: 'category',
                        data: [],
                        axisLabel: {
                            inside: true,
                            padding: [0, 0, 20, 0],
                            interval: 0,
                            formatter: (name, index) => {
                                const _index = index + 1;
                                const id = _index > 9 ? _index : `0${_index}`;
                                return `{num|${id}}{value|${name}}\n`;
                            },
                            rich: {
                                num: {
                                    //定位
                                    width: 18,
                                    height: 18,
                                    color: '#fff',
                                    fontSize: 11,
                                    align: 'center',
                                    fontFamily: 'PingFang SC',
                                    fontWeight: 500,
                                    backgroundColor: {
                                         image: img
                                    },
                                },
                                value: {
                                    padding: [0, 0, 0, 10],
                                    fontSize: 16,
                                    align: 'center',
                                    color: '#fff',
                                    fontFamily: 'PingFang SC',
                                    fontWeight: 500
                                },
                            },
                        },
                        splitLine: {
                            show: false,
                        },
                        axisTick: {
                            show: false,
                        },
                        axisLine: {
                            show: false,
                        },
                    },
                    {
                        //左侧柱状图的Y轴
                        gridIndex: 0, //y轴所在的 grid 的索引
                        splitLine: 'none',
                        axisTick: 'none',
                        axisLine: 'none',
                        data: [],
                        inverse: true,

                        axisLabel: {
                            show: true,
                            align: 'right',
                            padding: [0, 10, 30, 0],
                            formatter: function (value) {
                                return '{x|' + value + '}';
                            },
                            rich: {
                                x: {
                                    color: '#fff',
                                    fontSize: 16,
                                    fontFamily: 'PingFang SC',
                                    fontWeight: 500
                                }
                            },
                        },
                    },
                ],

                series: [
                    {
                        name: '右侧圆',
                        type: 'pictorialBar',
                        silent: true,
                        realtimeSort: true,
                        symbol: 'image://' + require('@/assets/img/symbol_circle.jpg'),
                        symbolSize: [17, 17],
                        symbolPosition: 'end',
                        symbolOffset: [5, 1],
                        z: 12,
                        label: {
                            normal: {
                                show: false,
                            },
                        },
                        color: '#FF9000',
                        data: [],
                        barCategoryGap: 140,
                    },
                    {
                        name: '值',
                        type: 'bar',
                        realtimeSort: true,
                        xAxisIndex: 0,
                        barWidth: 8,
                        barCategoryGap: 140,
                        itemStyle: {
                            normal: {
                                borderRadius: 0,
                                color: "#facc66",
                            },
                        },
                        data: [],
                        z: 0,
                    },
                    {
                        name: '背景',
                        type: 'bar',
                        barWidth: 8,
                        realtimeSort: true,
                        barCategoryGap: 140,
                        barGap: '-100%',
                        data: [],
                        itemStyle: {
                            normal: {
                                color: '#a80000',
                                borderWidth: 0
                            },
                        },
                        z: -1,
                    }
                ],
            },
            secondChartOptions: {
                grid: {
                    left: 0,
                    right: 10,
                    bottom: 20,
                    top: 20,
                    height: 2248
                },
                legend: {
                    show: false
                },
                xAxis: [
                    {
                        type: "value",
                        axisLabel: {
                            show: false,
                        },
                        interval: 0,
                        min: 0,
                        max: 'dataMax', // 计算最大值
                        splitLine: {
                            show: false,
                        },
                        axisLine: {
                            show: false,
                        },
                        axisTick: {
                            show: false,
                        },
                    }
                ],
                yAxis: [
                    {
                        inverse: true,
                        type: 'category',
                        data: [],
                        axisLabel: {
                            inside: true,
                            padding: [0, 0, 20, 0],
                            interval: 0,
                            formatter: (name, index) => {
                                const _index = index + 1;
                                const id = _index > 9 ? _index : `0${_index}`;
                                return `{num|${id}}{value|${name}}\n`;
                            },
                            rich: {
                                num: {
                                    //定位
                                    width: 18,
                                    height: 18,
                                    color: '#fff',
                                    fontSize: 11,
                                    align: 'center',
                                    fontFamily: 'PingFang SC',
                                    fontWeight: 500,
                                    backgroundColor: {
                                         image: img
                                    },
                                },
                                value: {
                                    padding: [0, 0, 0, 10],
                                    fontSize: 16,
                                    align: 'center',
                                    color: '#fff',
                                    fontFamily: 'PingFang SC',
                                    fontWeight: 500
                                },
                            },
                        },
                        splitLine: {
                            show: false,
                        },
                        axisTick: {
                            show: false,
                        },
                        axisLine: {
                            show: false,
                        },
                    },
                    {
                        //左侧柱状图的Y轴
                        gridIndex: 0, //y轴所在的 grid 的索引
                        splitLine: 'none',
                        axisTick: 'none',
                        axisLine: 'none',
                        data: [],
                        inverse: true,

                        axisLabel: {
                            show: true,
                            align: 'right',
                            padding: [0, 10, 30, 0],
                            formatter: function (value) {
                                return '{x|' + value + '}';
                            },
                            rich: {
                                x: {
                                    color: '#fff',
                                    fontSize: 16,
                                    fontFamily: 'PingFang SC',
                                    fontWeight: 500
                                }
                            },
                        },
                    },
                ],

                series: [
                    {
                        name: '右侧圆',
                        type: 'pictorialBar',
                        silent: true,
                        realtimeSort: true,
                        symbol: 'image://' + require('@/assets/img/symbol_circle.jpg'),
                        symbolSize: [17, 17],
                        symbolPosition: 'end',
                        symbolOffset: [5, 1],
                        z: 12,
                        label: {
                            normal: {
                                show: false,
                            },
                        },
                        color: '#FF9000',
                        data: [],
                        barCategoryGap: 140,
                    },
                    {
                        name: '值',
                        type: 'bar',
                        realtimeSort: true,
                        xAxisIndex: 0,
                        barWidth: 8,
                        barCategoryGap: 140,
                        itemStyle: {
                            normal: {
                                borderRadius: 0,
                                color: "#facc66",
                            },
                        },
                        data: [],
                        z: 0,
                    },
                    {
                        name: '背景',
                        type: 'bar',
                        barWidth: 8,
                        realtimeSort: true,
                        barCategoryGap: 140,
                        barGap: '-100%',
                        data: [],
                        itemStyle: {
                            normal: {
                                color: '#a80000',
                                borderWidth: 0
                            },
                        },
                        z: -1,
                    }
                ],
            },
            thirdChartOptions: {
                grid: {
                    left: 0,
                    right: 10,
                    bottom: 20,
                    top: 20,
                    height: 5362
                },
                legend: {
                    show: false
                },
                xAxis: [
                    {
                        type: "value",
                        axisLabel: {
                            show: false,
                        },
                        interval: 0,
                        min: 0,
                        max: 'dataMax', // 计算最大值
                        splitLine: {
                            show: false,
                        },
                        axisLine: {
                            show: false,
                        },
                        axisTick: {
                            show: false,
                        },
                    }
                ],
                yAxis: [
                    {
                        inverse: true,
                        type: 'category',
                        data: [],
                        axisLabel: {
                            inside: true,
                            padding: [0, 0, 20, 0],
                            interval: 0,
                            formatter: (name, index) => {
                                const _index = index + 1;
                                const id = _index > 9 ? _index : `0${_index}`;
                                return `{num|${id}}{value|${name}}\n`;
                            },
                            rich: {
                                num: {
                                    //定位
                                    width: 18,
                                    height: 18,
                                    color: '#fff',
                                    fontSize: 11,
                                    align: 'center',
                                    fontFamily: 'PingFang SC',
                                    fontWeight: 500,
                                    backgroundColor: {
                                         image: img
                                    },
                                },
                                value: {
                                    padding: [0, 0, 0, 10],
                                    fontSize: 16,
                                    align: 'center',
                                    color: '#fff',
                                    fontFamily: 'PingFang SC',
                                    fontWeight: 500
                                },
                            },
                        },
                        splitLine: {
                            show: false,
                        },
                        axisTick: {
                            show: false,
                        },
                        axisLine: {
                            show: false,
                        },
                    },
                    {
                        //左侧柱状图的Y轴
                        gridIndex: 0, //y轴所在的 grid 的索引
                        splitLine: 'none',
                        axisTick: 'none',
                        axisLine: 'none',
                        data: [],
                        inverse: true,

                        axisLabel: {
                            show: true,
                            align: 'right',
                            padding: [0, 10, 30, 0],
                            formatter: function (value) {
                                return '{x|' + value + '}';
                            },
                            rich: {
                                x: {
                                    color: '#fff',
                                    fontSize: 16,
                                    fontFamily: 'PingFang SC',
                                    fontWeight: 500
                                }
                            },
                        },
                    },
                ],

                series: [
                    {
                        name: '右侧圆',
                        type: 'pictorialBar',
                        silent: true,
                        realtimeSort: true,
                        symbol: 'image://' + require('@/assets/img/symbol_circle.jpg'),
                        symbolSize: [17, 17],
                        symbolPosition: 'end',
                        symbolOffset: [5, 1],
                        z: 12,
                        label: {
                            normal: {
                                show: false,
                            },
                        },
                        color: '#FF9000',
                        data: [],
                        barCategoryGap: 140,
                    },
                    {
                        name: '值',
                        type: 'bar',
                        realtimeSort: true,
                        xAxisIndex: 0,
                        barWidth: 8,
                        barCategoryGap: 140,
                        itemStyle: {
                            normal: {
                                borderRadius: 0,
                                color: "#facc66",
                            },
                        },
                        data: [],
                        z: 0,
                    },
                    {
                        name: '背景',
                        type: 'bar',
                        barWidth: 8,
                        realtimeSort: true,
                        barCategoryGap: 140,
                        barGap: '-100%',
                        data: [],
                        itemStyle: {
                            normal: {
                                color: '#a80000',
                                borderWidth: 0
                            },
                        },
                        z: -1,
                    }
                ],
            },
            tab:1,
        }
    },
    watch: {
        tp(val) {
            if(val){
                this.handleShow()
            }else{
                this.handleHidden()
            }
        },
        voteJson16020(val) {
            const data = val.voteItems;
            if (!data) {
                return
            }
            const result = cityInfo.map(item => {
                const res = data.filter(i => i.id === item.id);
                if (res && res.length > 0) {
                    return {
                        id: res[0].id,
                        name: item.name,
                        thumbUp: res[0].thumbUp
                    }
                } else {
                    return {
                        id: item.id,
                        name: item.name,
                        thumbUp: 0
                    }
                }
            });
            const sData = result.map(item => item.name);

            const thumbUps = result.map(item => item.thumbUp);

            this.thumbUps = thumbUps;


            this.chartOptions.yAxis[0].data = sData;
            this.chartOptions.yAxis[1].data = thumbUps;
            this.chartOptions.series[0].data = thumbUps;
            this.chartOptions.series[1].data = thumbUps;



            let big = 0;
            thumbUps.forEach((el) => {
                if (!(el === undefined || el === '' || el === 0)) {
                    if (big < Number(el)) {
                        big = Number(el);
                    }
                } else {
                    big = 100;
                }
            });

            const seriesDataBg = [];
            for (let i = 0; i < thumbUps.length; i++) {
                seriesDataBg.push(big * 1.1);
            }
            this.chartOptions.series[2].data = seriesDataBg;



            const secondresult = gzwInfo.map(item => {
                const res = data.filter(i => i.id === item.id);
                if (res && res.length > 0) {
                    return {
                        id: res[0].id,
                        name: item.name,
                        thumbUp: res[0].thumbUp
                    }
                } else {
                    return {
                        id: item.id,
                        name: item.name,
                        thumbUp: 0
                    }
                }
            });
            const secondsData = secondresult.map(item => item.name);

            const secondthumbUps = secondresult.map(item => item.thumbUp);

            this.secondthumbUps = secondthumbUps;


            this.secondChartOptions.yAxis[0].data = secondsData;
            this.secondChartOptions.yAxis[1].data = secondthumbUps;
            this.secondChartOptions.series[0].data = secondthumbUps;
            this.secondChartOptions.series[1].data = secondthumbUps;



            let secondbig = 0;
            secondthumbUps.forEach((el) => {
                if (!(el === undefined || el === '' || el === 0)) {
                    if (secondbig < Number(el)) {
                        secondbig = Number(el);
                    }
                } else {
                    secondbig = 100;
                }
            });

            const secondseriesDataBg = [];
            for (let i = 0; i < secondthumbUps.length; i++) {
                secondseriesDataBg.push(secondbig * 1.1);
            }
            this.secondChartOptions.series[2].data = secondseriesDataBg;

            const thirdresult = dfInfo.map(item => {
                const res = data.filter(i => i.id === item.id);
                if (res && res.length > 0) {
                    return {
                        id: res[0].id,
                        name: item.name,
                        thumbUp: res[0].thumbUp
                    }
                } else {
                    return {
                        id: item.id,
                        name: item.name,
                        thumbUp: 0
                    }
                }
            });
            const thirdData = thirdresult.map(item => item.name);

            const thirdthumbUps = thirdresult.map(item => item.thumbUp);

            this.thirdthumbUps = thirdthumbUps;


            this.thirdChartOptions.yAxis[0].data = thirdData;
            this.thirdChartOptions.yAxis[1].data = thirdthumbUps;
            this.thirdChartOptions.series[0].data = thirdthumbUps;
            this.thirdChartOptions.series[1].data = thirdthumbUps;



            let thirdbig = 0;
            thirdthumbUps.forEach((el) => {
                if (!(el === undefined || el === '' || el === 0)) {
                    if (thirdbig < Number(el)) {
                        thirdbig = Number(el);
                    }
                } else {
                    thirdbig = 100;
                }
            });

            const thirdseriesDataBg = [];
            for (let i = 0; i < thirdthumbUps.length; i++) {
                thirdseriesDataBg.push(thirdbig * 1.1);
            }
            this.thirdChartOptions.series[2].data = thirdseriesDataBg;

            this.run()
        }
    },
    beforeDestroy() {
        clearInterval(this.timer);
        this.timer = null;
    },
    computed: {
        ...mapState('common', {
            voteJson16020: state => state.voteJson16020,
            tp: state => state.tp
        }),
    },
    methods: {
        ...mapMutations('common', ['SET_VOTE_JSON','SET_TP']),
        set_tp_true(){
            this['SET_TP'](true)
        },
        set_tp_false(){
            this['SET_TP'](false)
        },
        changeData() {
            const self = this;
            self.getVote()
            this.timer = setInterval(function () {
                self.getVote();
            }, 30000);
        },
        run() {
            const self = this;
            // 重新改写chartOptions，以适应FEcharts里面监听options
            self.chartOptions.series[0].data = this.thumbUps;
            self.chartOptions = { ...self.chartOptions }
            self.secondChartOptions.series[0].data = this.secondthumbUps;
         
            self.secondChartOptions = { ...self.secondChartOptions }

            self.thirdChartOptions.series[0].data = this.thirdthumbUps;
            self.thirdChartOptions = { ...self.thirdChartOptions }
            
        },
        handleHidden() {
            this.popularityHidden = false;
            clearInterval(this.timer);
            this.timer = null;
        },
        handleShow() {
            this.popularityHidden = true;
            this.changeData()
        },
        async getVote() {
            await $.getScript("//app1.vote.cctv.com/viewVoteAction.do?voteId=16020&type=json&refresh=1")

            this['SET_VOTE_JSON'](voteJson16020)
        },
        choseTab(num){
            this.tab = num;
        }
    },
    created() {

    }
}
</script>

<style lang="scss" scoped>
.popularity {
    width: 1104px;
    height: auto;

    // position: absolute;
    // z-index: 9;
    // top: 40px;
    // left: 50%;
    // transform: translateX(-50%);
    // box-sizing: border-box;
    .popularity-pull {
        position: absolute;
        top: 0px;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        flex-direction: column;
        align-items: center;
        opacity: 1;
        transition: all 0.4s linear;
        transition-delay: 0.2s;
        z-index: 100009;

        .popularity-pull-top {
            width: 859px;
            height: 28px;
            line-height: 28px;
            background: #282828;
            opacity: 0.9;
            border-radius: 0px 0px 9px 9px;
            color: #fff;
            text-align: center;
            font-size: 16px;
        }

        .popularity-pull-bottom {
            width: 272px;
            height: 24px;
            background: #800000;
            border-radius: 0px 0px 12px 12px;
            background-image: url("../../assets/img/down-btn.png");
            background-repeat: no-repeat;
            background-size: 100% 100%;
            cursor: pointer;
        }
    }

    .popularity-push {
        position: absolute;
        z-index: 9;
        top: -100%;
        left: 50%;
        transform: translateX(-50%);
        // background-color: rgba(0, 0, 0, 0.8);
        border-radius: 12px;
        transition: all 0.8s linear;
        transition-delay: 0s;

        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-position: center;
        background-image: url(../../assets/img/ph-bg.png);
    }

    .popularityHidden {
        top: 40px;
        padding: 25px;
        transition-delay: 0.2s;
        z-index: 100009;
    }

    .popularityShow {
        opacity: 0;
        transition-delay: 0s;
    }

    .popularity-chart {
        width: 1054px;
        height: 557px;
        overflow: hidden;

        ::v-deep .el-scrollbar__wrap {
            overflow-x: hidden;
        }
    }

    .top-bar {
        width: 1054px;
        height: 32px;
        // background: rgba(#C36A15, 0.4);
        background: url('~@/assets/img/popularity/popularity-topbar-bg.png') no-repeat center;
        background-size: cover;
        // border: 1px solid #E88C00;
        line-height: 32px;
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: 800;
        color: #FFFFFF;
        position: relative;
        text-align: left;
        padding-left: 26px;

        // margin-top: 27px;
        // margin-left: 25px;
        &::before {
            content: '';
            display: block;
            width: 4px;
            height: 20px;
            background: #D82900;
            top: 6px;
            left: 15px;
            position: absolute;
        }

        &::after {
            content: '';
            display: block;
            background: url('~@/assets/img/popularity/popularity-topbar-right-icon.png') no-repeat center;
            background-size: contain;
            width: 18px;
            height: 12px;
            position: absolute;
            top: 10px;
            right: 8px;
        }
    }
    .tab-box{
        width: 1052px;
        height: 32px;
        // background: rgba(#C36A15, 0.4);
        background: url('~@/assets/img/popularity/popularity-tab-bg.png') no-repeat center;
        background-size: cover;
        // border: 1px solid #E88C00;
        line-height: 32px;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 600;
        color: #FFFFFF;
        position: relative;
        text-align: left;
        display: flex;

        .tab-item{
            width: 50%;
            text-align: center;
            cursor: pointer;
            &.active{
                font-size: 18px;
                font-weight: 800;
                color: #a01b0c;
                background: url('~@/assets/img/popularity/active-bg.png') no-repeat center;
                background-size: 110% 100%;
                border-radius: 0;
            }
        }
    }

    .bottom-bar {
        width: 1054px;
        height: 60px;
        border-radius: 0 0 12px 12px;
        background: #800000 url('~@/assets/img/popularity/pupularity-stretch-icon.png') no-repeat center;
        // background-image: url('~@/assets/img/popularity/pupularity-stretch-icon.png');
        background-size: 32px 20px;
        cursor: pointer;
        // background-repeat: no-repeat;
        // background-size: 100% 100%;
        // background-position: center;
    }

    .gzw, .df{
        background-color: #a21408;
        position: relative;
        cursor: pointer;
        color: #fff;
        z-index: 999;
        font-size: 16px;
        // opacity: 0.8;
    }
    .gzw1, .df1{
        background-color: #b75a54;
        position: relative;
        cursor: pointer;
        color: #fff;
        z-index: 999;
        font-size: 16px;
    }
}
</style>
<style lang="scss">
.popularity-chart {
    width: 1054px;
    height: 557px;
    overflow: hidden;

    .el-scrollbar__wrap {
        overflow-x: hidden;
    }
}
</style>